import { css } from "styled-components"

export const outerSpacing = css`
  padding: 0 ${(props) => props.theme.space.s};

  @media screen and (min-width: ${(props) => props.theme.breakpoint.sm}) {
    padding: 0 ${(props) => props.theme.space.m};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.md}) {
    padding: 0 ${(props) => props.theme.space.l};
  }
`
